import { Formik } from 'formik'
import PropTypes from 'prop-types'
import { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import Button from '@/components/Button'
import { Text } from '@/components/Form'
import { Error } from '@/components/Icons'

import './index.scss'

import messages from './messages'

export default class SpaceDeleteConfirmationOverlay extends Component<any, any> {
  static displayName = 'SpaceDeleteConfirmationOverlay'

  static propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    spaceName: PropTypes.string.isRequired
  }

  state = { spaceNameConfirmation: '' }

  confirmSpace = () => {
    return this.state.spaceNameConfirmation === this.props.spaceName
  }

  onConfirmationChange = (e: any) => {
    this.setState({ spaceNameConfirmation: e.target.value })
  }

  render() {
    const { spaceName, onConfirm, onCancel } = this.props
    return (
      <div className="confirmation__overlay">
        <div className="confirmation__box">
          <p className="confirmation__message">
            <FormattedMessage {...messages.deleteSpace} />
          </p>
          <div className="confirmation__warning_block_wrapper">
            <div className="confirmation__icon">
              <Error />
            </div>
            <div className="confirmation__warning_block">
              <p>
                <FormattedMessage
                  {...messages.deleteConfirm}
                  values={{
                    spaceName: <span className="confirmation__space_name">{spaceName}</span>
                  }}
                />
              </p>
            </div>
          </div>
          <p className="confirmation__sub_message">
            <FormattedMessage {...messages.subMessage} />
          </p>
          {/* @ts-expect-error */}
          <Formik initialValues={{ spaceName: '' }}>
            <Text
              name="spaceName"
              label={<FormattedMessage {...messages.confirm} />}
              onChange={this.onConfirmationChange}
            />
          </Formik>
          <div className="confirmation__actionblock">
            <Button color="secondary" onClick={onCancel}>
              <FormattedMessage {...messages.cancel} />
            </Button>
            <Button color="warning" onClick={onConfirm} disabled={!this.confirmSpace()}>
              <FormattedMessage {...messages.delete} />
            </Button>
          </div>
        </div>
      </div>
    )
  }
}
